import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { OpinionFormik } from 'components/OpinionFormik';
import { usePageTitle } from 'routes/Util/Util.hooks';

export const ArticlesNewPage = () => {
  usePageTitle('글 작성');

  return (
    <Container>
      <Row>
        <Col>
          <OpinionFormik />
        </Col>
      </Row>
    </Container>
  )
}
